"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { Suspense, useEffect } from "react";
import { scrubPreviewToken } from "@/lib/analytics/scrub-url";

function Tracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (!pathname) return;
    let url = window.origin + pathname;
    const qs = searchParams.toString();
    if (qs) url += `?${qs}`;
    // Lazy import keeps posthog-js out of the first-load bundle; same singleton
    // Analytics.init'd. No-op while opted out (pre-consent) — PostHog guards
    // capture internally.
    void import("posthog-js").then(({ default: posthog }) => {
      // Never ship a CMS preview token to a third party (lib/analytics/scrub-url.ts).
      posthog.capture("$pageview", { $current_url: scrubPreviewToken(url) });
    });
  }, [pathname, searchParams]);

  return null;
}

/**
 * Manual `$pageview` capture on client navigation (App Router fires no full
 * reload). `useSearchParams` must sit under `<Suspense>` or it opts the whole
 * tree into client-side rendering.
 */
export function PostHogPageView() {
  return (
    <Suspense fallback={null}>
      <Tracker />
    </Suspense>
  );
}
